//Library Imports
import styled from 'styled-components';

// CSS Imports
import './RobotoFont.css';

export const RobotoFontWrapper = styled.div`
    font-family: 'Roboto', sans-serif;
`;
